<template>
    <div id="body">
        <b-container>
            <div>
                <div class="box-result w-100">
                    <div class="box-result-header">
                        <img src="@/assets/ver2/ketqua.png" alt="">
                    </div>
                    <div class="box-result-table p-3">
                        <div class="part-result mb-5" v-for="(part, index) in result" :key="index">
                            <div v-if="part.part_type !== 1">
                                <div class="result-title">
                                    {{ part.name }}
                                    <div class="result-detail">
                                        {{ calcResult(part.answered) }}
                                    </div>
                                </div>
                                <div class="result-body mt-4">
                                    <div class="row">
                                        <div class="col-md-3 col-4 col-lg-2 mb-3 " v-for="(answer, indexAns) in part.answered" :key="indexAns">
                                            <div class="w-100 shadow border rounded p-2 d-flex align-items-center justify-content-center">
                                                <p class="fw-bold m-0 me-2" style="font-size: 18px;">{{ indexAns + 1 }}</p>
                                                <svg v-if="answer === 'false'" width="26" height="26" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="3 3 16 16"><defs><linearGradient gradientUnits="userSpaceOnUse" y2="-2.623" x2="0" y1="986.67"><stop stop-color="#ffce3b"/><stop offset="1" stop-color="#ffd762"/></linearGradient><linearGradient id="0" gradientUnits="userSpaceOnUse" y1="986.67" x2="0" y2="-2.623"><stop stop-color="#ffce3b"/><stop offset="1" stop-color="#fef4ab"/></linearGradient><linearGradient gradientUnits="userSpaceOnUse" x2="1" x1="0" xlink:href="#0"/></defs><g transform="matrix(2 0 0 2-11-2071.72)"><path transform="translate(7 1037.36)" d="m4 0c-2.216 0-4 1.784-4 4 0 2.216 1.784 4 4 4 2.216 0 4-1.784 4-4 0-2.216-1.784-4-4-4" fill="#da4453"/><path d="m11.906 1041.46l.99-.99c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.458-.458c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.99.99-.99-.99c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.458.458c-.063.063-.094.139-.094.229 0 .09.031.166.094.229l.99.99-.99.99c-.063.062-.094.139-.094.229 0 .09.031.166.094.229l.458.458c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.99-.99.99.99c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.458-.458c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.99-.99" fill="#fff"/></g></svg>
                                                <svg v-if="answer === 'true'" width="26" height="26" xmlns="http://www.w3.org/2000/svg" viewBox="3 3 16 16"><defs><linearGradient gradientUnits="userSpaceOnUse" y2="-2.623" x2="0" y1="986.67" id="0"><stop stop-color="#ffce3b"/><stop offset="1" stop-color="#ffd762"/></linearGradient><linearGradient y2="-2.623" x2="0" y1="986.67" gradientUnits="userSpaceOnUse"><stop stop-color="#ffce3b"/><stop offset="1" stop-color="#fef4ab"/></linearGradient></defs><g transform="matrix(1.99997 0 0 1.99997-10.994-2071.68)" fill="#da4453"><rect y="1037.36" x="7" height="8" width="8" fill="#32c671" rx="4"/><path d="m123.86 12.966l-11.08-11.08c-1.52-1.521-3.368-2.281-5.54-2.281-2.173 0-4.02.76-5.541 2.281l-53.45 53.53-23.953-24.04c-1.521-1.521-3.368-2.281-5.54-2.281-2.173 0-4.02.76-5.541 2.281l-11.08 11.08c-1.521 1.521-2.281 3.368-2.281 5.541 0 2.172.76 4.02 2.281 5.54l29.493 29.493 11.08 11.08c1.52 1.521 3.367 2.281 5.54 2.281 2.172 0 4.02-.761 5.54-2.281l11.08-11.08 58.986-58.986c1.52-1.521 2.281-3.368 2.281-5.541.0001-2.172-.761-4.02-2.281-5.54" fill="#fff" transform="matrix(.0436 0 0 .0436 8.177 1039.72)" stroke="none" stroke-width="9.512"/></g></svg>                                        
                                            </div>    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="box-result-footer">
                        <img src="@/assets/ver2/overall.png" alt="">
                        <div class="box-result-footer-rate">
                            <span>20</span>/<span>30</span>
                        </div>
                    </div>
                     -->
                </div>
                <div class="box-footer">
                    <img class="button-save" src="@/assets/ver2/button_save.png" alt="" @click="reloadPage()">
                    <!-- <img class="button-support" src="@/assets/ver2/support_tutorial.png" alt=""> -->
                </div>
            </div>
            
            
        </b-container>
    </div>
</template>

<script>
export default {
    
    components: {
        
    },
    computed: {
       
    },
    data () {
        return {
            result: []
        }
    },
    watch: {
    },
    methods: {
        reloadPage () {
            this.$TestApp.testSubmit();
            this.$TestApp.goToPage(9);
        },
        calcResult (answered) {
            
            if (answered) {
                const answerRightCount = answered.filter(el => el === 'true').length
                return `${answerRightCount}/${answered.length}`
            }

            return '0/0'
        }
    },
    created() {
        this.$TestApp.getTestResult()
        .then(data => {
            const { test_result } = data
            this.result = test_result
            this.$TestApp.testNewSession()
        })
    }
}
</script>
<style lang="scss" scoped>

.result-title {
    border-radius: 16px;
    border: 3px solid #000;
    height: max-content;
    font-family: 'Montserrat', sans-serif;
    background: url('~@/assets/ver2/background-button.png');
    color: white;
    text-transform: uppercase;
    font-size: 1.4rem;
    font-weight: 900;
    min-width: 13.5rem;
    font-style: italic;
    text-shadow: 3px 0 #000, -3px 0 #000, 0 2px #000, 0 -3px #000,
            2px 2px #000, -2px -2px #000, 2px -2px #000, -2px 2px #000;
    padding: 4px 20px 4px 14px;
    box-shadow: 4px 4px 0px #008844;
    
    position: relative;
    margin-right: 120px;

    display: flex;
    align-items: center;
    width: max-content;

    .result-detail {
        text-shadow: none;
        color: #000;
        background-color: #fff;
        border-radius: 10px;
        margin-left: 10px;
        padding: 6px 10px;
    }
}

.box-result {
    margin-top: 8rem;
    width: 75rem;
    text-align: center;
    border: 2px solid;
    border-radius: 20px;
    background: white;
    &-header {
        position: relative;
        top: -6rem;
        left: -3rem;
        img{
            max-width: 64rem;
        }
    }
    &-table {        
        
        max-width: 900px;
        margin: auto;

        .custom_th {
            padding:0rem;
            background: url('../../assets/ver2/background-table.jpg');
            background-size: auto;
            &-rate {
                background: white;
                padding: 0rem 1rem;
                border-radius: 10px;
                font-weight: 700;
                margin: 0.4rem 0.5rem;
                font-style: italic;
            }
            &-label {
                margin-left: 2rem;
                color: white;
                font-style: italic;
                text-transform: uppercase;
                font-size: 1.6rem;
                text-shadow: -3px 0 black, -3px 1px black, 0 3px black, 0 -3px black, 2px 0px black, 2px -3px black, 3px -3px black, -3px 3px black
            }
        }
    }
    &-footer {
        position: relative;
        img {
            max-width: 20rem;
        }
        &-rate {
            position: absolute;
            left: 53.8%;
            bottom: 31%;
            font-size: 2rem;
            font-weight: 700;
            font-style: italic;
        }
    }
    
}
.box-footer {
    text-align: center;
    position: relative;
    margin-top: 1rem;
    .button-save, .button-support {
        position: relative;
        cursor: pointer;
    }
    .button-save {
        max-width: 14rem;
        left: 4rem;
    }
    .button-support {
        right: -20rem;
        top: -2rem;
        max-width: 15rem;
        @media (min-width: 720px) and (max-width: 992px) {
            right: -19rem;
        }
    }
    
}
</style>